<template>
  <div class="main-content">
    <span style="position: absolute; left: 20px;">{{ title }}</span>
    <div style="float: right;padding-right: 5px;">
      <el-button type="primary" :disabled="!isEdit" @click="addCommerceResponsiblePersonHandler">{{ '+' + $t('CargoMsg.Cargo_add') + $t('SeaExport.ResponsiblePerson') }}</el-button>
    </div>
    <div class="section grid-wrapper" style="height: 250px">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
  </div>
</template>

<script>
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { User } from '@/class/model/sys/User'
import { DocumentManage } from '@/utils/commonUtil'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'

export default {
  name: 'TabCommerceResponsiblePerson',
  props: {
    isEdit: { type: Boolean, default: false },
    commerce: { type: Object, required: true },
    title: { type: String, required: true },
    type: { type: Number, default: 0 }
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        rowHeight: 32,
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridAdvanceMultipleSelectEditor
        },
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        context: {
          componentParent: this
        }
      },
      documentManage: new DocumentManage(),
      rowData: [],
      gridApi: null,
      basicCachePorts: [],
      basicCacheUsers: [], // 负责人名称
      seaList: [],
      airList: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 100,
          minWidth: 100,
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          cellRenderer: params => {
            if (this.isEdit) {
              const onDel = this.documentManage.getPath('onDel')
              return `<div><a onclick="${onDel}(${params.node.rowIndex})" style="color:#1F75D5;font-size:25px;">-</a></div>`
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_NamePersonResponsible'),
          field: 'userId',
          colId: 'userId',
          minWidth: 550,
          width: 550,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_User,
              tagValue: 'userId',
              tagName: 'chineseName',
              filterable: true,
              staticOptions: this.basicCacheUsers
            }
          },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ResponsiblePortDeparture'),
          field: 'port',
          colId: 'port',
          width: 550,
          minWidth: 550,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
          cellEditorParams: {
            selectProps: {
              // staticOptions: this.basicCachePorts,
              selectType: TYPE_NAMES.basic_data_Seaport,
              tagName: 'englishName',
              tagValue: 'code',
              filterable: true,
              clearable: true,
              multiple: true,
              showCustomLabelInOption: true
            }
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        }
      ]
    }
  },
  watch: {
    isEdit(newVal) {
      if (!newVal) {
        this.loadGridDataHandler()
      }
    },
    commerce: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.loadGridDataHandler()
          })
        }
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.initBasicCachePorts()
    await this.initBasicCacheUsers()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onDel', function(value) {
      context.onDel(value)
    })
  },
  methods: {
    async onShow() {
      await this.$nextTick()
      this.loadGridDataHandler()
    },
    initBasicCachePorts() {
      const seaPort = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Seaport) || []
      if (seaPort && seaPort.length > 0) {
        this.basicCachePorts.push(...seaPort)
      }
      const airPort = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Airport) || []
      if (airPort && airPort.length > 0) {
        this.basicCachePorts.push(...airPort)
      }
      console.log('this.basicCachePorts', this.basicCachePorts)
    },
    checkUserRole(userId) {
      const user = this.basicCacheUsers.find(u => u.userId === userId)
      let t = ''
      if (user) {
        if (this.seaList != null && this.airList != null && this.seaList.includes(user) && this.airList.includes(user)) {
          t = 'ALL-' + user.userId
        } else if (this.seaList.includes(user)) {
          t = 'SE-' + user.userId
        } else if (this.airList.includes(user)) {
          t = 'AE-' + user.userId
        }
      }
      return t
    },
    async initBasicCacheUsers() {
      this.seaList = await User.getUsersByPrivilegeDetail('role', 'sealine', null, this.$store.getters.currentOfficeId)
      this.airList = await User.getUsersByPrivilegeDetail('role', 'airline', null, this.$store.getters.currentOfficeId)
      for (const s of this.seaList) {
        if (this.basicCacheUsers.findIndex(el => el.userId === s.userId) === -1) {
          this.basicCacheUsers.push(s)
        }
      }
      for (const a of this.airList) {
        if (this.basicCacheUsers.findIndex(el => el.userId === a.userId) === -1) {
          this.basicCacheUsers.push(a)
        }
      }
    },
    addCommerceResponsiblePersonHandler() {
      const commerceResponsiblePerson = {}
      commerceResponsiblePerson.commerceUuid = this.commerce.uuid
      commerceResponsiblePerson.type = this.type
      commerceResponsiblePerson.userId = 0
      commerceResponsiblePerson.port = ''
      this.rowData.push(commerceResponsiblePerson)
      if (!this.commerce.commerceResponsiblePersonVos) {
        this.commerce.commerceResponsiblePersonVos = []
      }
      this.commerce.commerceResponsiblePersonVos.push(commerceResponsiblePerson)
      console.log('add commerce ', this.commerce)
    },
    onDel(index) {
      // const index = this.rowData.findIndex(row => row.uuid === uuid)
      if (index > -1) {
        const row = this.rowData[index]
        // 直接删除列表元素
        this.rowData.splice(index, 1)
        // 删除实际列表元素
        const i = this.commerce.commerceResponsiblePersonVos.findIndex(p => p === row)
        if (i > -1) {
          this.commerce.commerceResponsiblePersonVos.splice(i, 1)
        }
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    onCellChange(params) {
      const commerceResponsiblePerson = params.data
      if (!commerceResponsiblePerson) {
        return
      }
      const key = params.field || params.colDef.colId
      switch (key) {
        case 'userId':
          commerceResponsiblePerson.prefix = this.checkUserRole(commerceResponsiblePerson.userId)
          break
        case 'port':
          console.log('params is', params)
          if (params.newValue && params.newValue.length > 0) {
            commerceResponsiblePerson.port = params.newValue.join()
          } else {
            commerceResponsiblePerson.port = ''
          }
          break
        default:
          break
      }
    },
    loadGridDataHandler() {
      this.rowData = []
      if (this.commerce && this.commerce.commerceResponsiblePersonVos) {
        const rowData = []
        for (const commerceResponsiblePerson of this.commerce.commerceResponsiblePersonVos) {
          if (commerceResponsiblePerson.type === this.type) {
            rowData.push(commerceResponsiblePerson)
          }
        }
        this.rowData = rowData
        // 确保数据加载后刷新表格
        this.$nextTick(() => {
          if (this.gridApi) {
            this.gridApi.refreshCells({ force: true })
          }
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
